<template>
  <div>
    {{ translate.result.coverageless.received }}
    <br />
    {{ translate.result.coverageless.instruction }}
    <br />
    {{ translate.result.coverageless.whatsapp }}
    <br />
    <br />
    {{ translate.result.coverageless.thanks }}

    <div v-if="supervisor" class="manual-card-wrapper">
      <supervisor-card :info="supervisor" />
    </div>
  </div>
</template>

<script>
import SupervisorCard from '../card/SupervisorCard.vue';
export default {
  name: 'coverageless-result',
  props: {
    supervisor: {
      type: Object,
      default: null,
    },
  },
  components: {
    SupervisorCard,
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
  },
};
</script>

<style lang="css" scoped>
.manual-card-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  margin-top: 15px;
}
</style>
